export default __webpack_public_path__ + "static/media/Mobile_Frame.b4d3145c.png";